export enum RoomType {
  CoordinatorDoctor = "DoctorCoordinator",
  CoordinatorPlanner = "PlannerCoordinator",
  CoordinatorFabricator = "FabricatorCoordinator",
}

export interface ChatRoomDto {
  id: string;
  caseId: string;
  roomType: RoomType;
  coordinatorIds: string[];
  coordinatorName: string;
  otherParticipantId: string;
  otherParticipantName: string;
  participants: ParticipantDto[];
  lastMessage?: string;
  lastMessageDate?: string;
  title: string;
  subtitle?: string;
  unreadCount: number;
  createdAt: string;
}

export interface ParticipantDto {
  userId: string;
  userName: string;
  userType: number;
}

export interface GetUserChatRoomsDto {
  pageNumber?: number;
  pageSize?: number;
}

export interface MarkRoomAsReadDto {
  roomId: string;
}
